import { Icon } from '@ps/isp-web-component-library';
import { Horse } from '@ps/isp-web-component-library/icons/Horse';
import type { MarketId, MeetingBasedMarketView } from '@ps/isp-web-services-types';
import type { Values } from '@ps/web-core-intl';
import { Link } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import RaceDetailsNextRaces from '@swf/sports/components/RaceDetailsNextRaces/RaceDetailsNextRaces';

import { useSportsNextRacesWidget } from '../model';

import styles from './RaceInfo.scss';

interface Props {
  marketId: MarketId;
}

const RaceInfo: React.FC<Props> = ({ marketId }) => {
  const { widgetSelect } = useSportsNextRacesWidget();

  const { meetingId, raceId } = useSelector(
    (state: RootState) => widgetSelect.market(state, marketId) as MeetingBasedMarketView
  );
  const { startTime, details } = useSelector((state: RootState) =>
    widgetSelect.race(state, raceId)
  );
  const { venue } = useSelector((state: RootState) => widgetSelect.meeting(state, meetingId));
  const raceCardLinkValues = useSelector((state: RootState) =>
    widgetSelect.raceCardLinkValues(state, marketId)
  );

  return (
    <Link
      className={styles.raceLink}
      alias="sportsAnimalRacingRace"
      values={raceCardLinkValues as unknown as Values}
    >
      <span className={styles.race}>
        <Icon icon={Horse} className={styles.chevron} size="lg" />
        <span>
          <span className={styles.time}>{<FormattedDateTime date={startTime} />}</span>
          {venue}
          {details ? <RaceDetailsNextRaces details={details} /> : null}
        </span>
      </span>
    </Link>
  );
};

export default RaceInfo;
